var map = {
	"./1foot.png": 653,
	"./1head.png": 654,
	"./2foot.png": 655,
	"./2head.png": 656,
	"./3foot.png": 657,
	"./3head.png": 658,
	"./4foot.png": 659,
	"./4head.png": 660,
	"./dark.png": 661,
	"./draft.png": 662,
	"./light.png": 663,
	"./logo.png": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 652;